export  default {
  layout:{

  },
  systemName:"全国援外培训管理信息系统",
  global: {
    day: '天',
    hour: '小时',
    minute: '分钟',
    confirm: '确定',
    cancel: '取消',
    yes: '是',
    no: '否',
    open: '打开',
    enabled: '启用',
    disabled: '禁用',
    delete: '删除',
    add: '添加',
    create: '新建',
    update: '更新',
    deploy: '发布',
    refresh: '刷新',
    close: '关闭',
    closeOther: '关闭其他',
    closeAll: '关闭所有',
    tip: '提示',
    handle: '操作',
    success: '成功',
    recover: '恢复',
    save: '保存',
    saveAndContinue: '保存并继续新建',
    autoSave: '自动保存',
    sort: '排序',
    index: '序号',
    prevPage: '上一页',
    nextPage: '下一页',
    screenFull: '全屏',
    cancelScreenFull: '退出全屏',
    download: '下载'
  },
}
